export interface WorldMapShape {
  path: string;
  id: string;
  excluded?: boolean;
  selected?: boolean;
}

export interface WorldMapData {
  value: number;
  scaledValue?: number;
  category: string;
  country: string;
}

export interface WorldMapGrowthData {
  country: string;
  growth: number;
}

export interface WorldMapCountry {
  count?: number;
  scaledCount?: number;
  id: string;
  data?: Array<WorldMapData>;
  excluded?: boolean;
  selected?: boolean;
}

export interface WorldMapPieArc {
  arc: string;
  color: string;
}
export interface WorldMapPie {
  data: WorldMapData;
  index?: number;
  value?: number;
  startAngle?: number;
  endAngle?: number;
  padAngle?: number;
}

// GEO data to draw the shapes
export interface WorldMapFeature {
  type: string;
  properties: {
    name: string;
  };
  geometry: {
    type: string;
    coordinates: Array<Array<number>>;
  };
  id: string;
  centroid: Array<number>;
  centroidOffset?: Array<number>;
}

export interface WorldMapCategoryMap {
  [key: string]: WorldMapCategory;
}

export interface WorldMapCategory {
  color?: string;
  label: string;
}

export enum WorldMapType {
  CHOROPLETH = 'choropleth',
  BUBBLE = 'bubble',
  PIE = 'pie',
  GROWTH = 'growth'
}

export enum WorldMapTooltipAlign {
  LEFT = 'left',
  RIGHT = 'right'
}
